import React, { useEffect, useState } from 'react';

import Title from '../Title';
import Label from '../Label';
import Input from '../Input';
import DatePickerExample from '../Calendar';
import Button from '../Button';
import { calculateResponses } from '../utils';

const Calculator = ({ onCalculate }) => {
  const [guestsValue, setGuestsValue] = useState('');
  const [dateValue, setDateValue] = useState('');
  const [isDisabledBtn, setIsDisabledBtn] = useState(true);

  useEffect(() => {
    guestsValue && dateValue ? setIsDisabledBtn(false) : setIsDisabledBtn(true);
  }, [dateValue, guestsValue]);

  const handleInputChange = (value) => {
    setGuestsValue(value);
  };

  const handleCalendarChange = (value) => {
    setDateValue(value);
  };

  const handleClick = () => {
    const {
      label_dates,
      responses_by_date,
      week_decline_data,
      week_accept_data,
    } = calculateResponses(guestsValue, dateValue);
    onCalculate(label_dates, responses_by_date, week_accept_data, week_decline_data);
  };

  return <div className='calculator'>
    <Title title='Add your data:' />
    <Label forHtml='guests' label='Number of guests invited:' />
    <Input onChange={handleInputChange} />
    <Label forHtml='calendar' label='Date invitations sent (or will be):' />
    <DatePickerExample onChange={handleCalendarChange} />
    <Button isDisabled={guestsValue <= 0 || isDisabledBtn} onClick={handleClick} />
  </div>;
};

export default Calculator;
